<template>
  <div
    class="h-80 w-full p-16 border-r border-l border-neutral-border border-b"
    :class="{
      'border-t rounded-t-12': isFirst,
      'rounded-b-12': isLast,
    }"
  >
    <div>
      <div class="flex gap-12 items-center">
        <BittsBone type="avatar" :width="32" :height="32" />
        <div class="flex w-full">
          <div class="w-full flex justify-between">
            <BittsBone type="heading" :width="getWidth(10)" :height="20" />
            <BittsBone type="heading" :width="20" :height="20" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsBone } from '@crossbeam/bitts';

const { isFirst, isLast } = defineProps<{
  isFirst: boolean;
  isLast: boolean;
}>();

function getWidth(multiplier: number) {
  return Math.floor(Math.max(20, Math.random() * multiplier));
}
</script>
